module.exports = __webpack_public_path__ + "static/img/210531glj.0b8076e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/210531glj.jpg
// module id = ZjWe
// module chunks = 0